import { combineReducers } from 'redux'

import {reducer as regionalEmbed} from 'lib/api/embeds/regional'
import {localeReducer as locale} from 'data/reducers/locale'

export const rootReducer = combineReducers({
  regionalEmbed,
  locale
})
